'use strict';

var angular = require('angular');
var GridToolbarStrategyListingDirective = function GridToolbarStrategyListingDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmGridPanel',
    template: require('../templates/grid-toolbar-strategy-listing.html'),
    controller: 'GridToolbarStrategyListingController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', scope.onRowSelection);
      scope.deleteStrategy = function () {
        angular.element('#delete-strategy-modal').appendTo('body').modal('show');
      };
    }
  };
};
GridToolbarStrategyListingDirective.$inject = [];
module.exports = GridToolbarStrategyListingDirective;